import { NgModule } from '@angular/core';
import { TermsAndConditionsModalComponent } from './terms-and-conditions-modal.component';
import { CheckboxComponent } from '@certemy/ui-components';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { TermsAndConditionsModule } from 'pages/static-pages/term-and-conditions/terms-and-conditions.module';

@NgModule({
  imports: [CertemyCommonModule, CheckboxComponent, TermsAndConditionsModule],
  declarations: [TermsAndConditionsModalComponent],
})
export class TermsAndConditionsModalModule {}
